<template>
  <a-modal title="种子仓库详情" :visible="visible" @cancel="visible = false" :footer="null" width="820px" :bodyStyle="{ paddingBottom: '0' }">
    <a-descriptions :column="2" bordered size="small" class="detail-desc">
      <a-descriptions-item label="仓库记录ID">{{ detail.id }}</a-descriptions-item>
      <a-descriptions-item label="用户ID">{{ detail.userId }}</a-descriptions-item>
      <a-descriptions-item label="用户昵称">{{ detail.userNickName }}</a-descriptions-item>
      <a-descriptions-item label="种子ID">{{ detail.seedId }}</a-descriptions-item>
      <a-descriptions-item label="种子名称">{{ detail.seedName }}</a-descriptions-item>
      <a-descriptions-item label="来源类型">{{ getSourceTypeName(detail.sourceType) }}</a-descriptions-item>
      <a-descriptions-item label="邮寄申请ID">{{ detail.mailApplyId }}</a-descriptions-item>
      <a-descriptions-item label="是否已种植">
        <a-tag :color="detail.isPlanted ? 'red' : 'green'">{{ detail.isPlanted ? '已种植' : '未种植' }}</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="种植土地ID">{{ detail.plantLandId }}</a-descriptions-item>
      <a-descriptions-item label="种植土地位置">{{ detail.landPosition }}</a-descriptions-item>
      <a-descriptions-item label="平台确认">
        <a-tag :color="detail.platformConfirmed === 1 ? 'green' : 'orange'">{{ detail.platformConfirmed === 1 ? '已确认' : '未确认' }}</a-tag>
      </a-descriptions-item>
<!--      <a-descriptions-item label="状态">-->
<!--        <a-tag :color="detail.status === 1 ? 'green' : 'red'">{{ detail.status === 1 ? '正常' : '禁用' }}</a-tag>-->
<!--      </a-descriptions-item>-->
      <a-descriptions-item label="创建时间">{{ detail.createTime }}</a-descriptions-item>
      <a-descriptions-item label="更新时间">{{ detail.updateTime }}</a-descriptions-item>
      <a-descriptions-item label="种子图片" :span="1">
        <img v-if="detail.seedImage" :src="detail.seedImage" style="width: 80px; height: 80px; object-fit: cover" />
      </a-descriptions-item>
      <a-descriptions-item label="备注" :span="1">{{ detail.remark }}</a-descriptions-item>
    </a-descriptions>
    <div class="detail-footer" v-if="detail.platformConfirmed !== 1">
      <a-button type="primary" @click="handleConfirm"><a-icon type="check" />确认</a-button>
    </div>
  </a-modal>
</template>

<style scoped>
.detail-footer {
  margin-top: 16px;
  text-align: right;
}
.detail-desc {
  margin-bottom: 0;
}
</style>

<script>
import { getSeedWarehouse, confirmSeedWarehouse } from '@/api/cloudplant/seedWarehouse'

export default {
  name: 'DetailModal',
  data() {
    return { visible: false, detail: {} }
  },
  methods: {
    getSourceTypeName(type) {
      const map = { 1: '购买', 2: '盲盒赠送', 3: '邮寄' }
      return map[type] || type
    },
    show(row) {
      getSeedWarehouse({ id: row.id }).then(response => {
        this.detail = response.data
        this.visible = true
      })
    },
    handleConfirm() {
      this.$confirm({
        title: '确认提示',
        content: '是否确认该种子？',
        onOk: () => {
          confirmSeedWarehouse({ id: this.detail.id }).then(() => {
            this.$message.success('确认成功')
            this.detail.platformConfirmed = 1
            this.visible = false
            this.$emit('ok')
          })
        }
      })
    }
  }
}
</script>
